import React from 'react';

const SimpleChart = ({ title, data, type = 'bar' }) => {
  const maxValue = Math.max(...data.map(d => d.value));

  if (type === 'bar') {
    return (
      <div className="glass-strong rounded-2xl p-6">
        <h3 className="text-xl font-bold text-brown-900 mb-6">{title}</h3>
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={index}>
              <div className="flex justify-between items-center mb-2">
                <span className="text-brown-800 font-medium text-sm">{item.label}</span>
                <span className="text-brown-700 font-semibold">{item.value}%</span>
              </div>
              <div className="w-full bg-brown-200/30 rounded-full h-4 overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-brown-600 to-brown-800 rounded-full transition-all duration-1000"
                  style={{ width: `${(item.value / maxValue) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'pie') {
    let currentAngle = 0;
    const radius = 80;
    const centerX = 100;
    const centerY = 100;
    const total = data.reduce((sum, item) => sum + item.value, 0);

    const colorMap = [
      { start: '#8d7762', end: '#615344' },
      { start: '#b8a893', end: '#8d7762' },
      { start: '#756352', end: '#574035' },
      { start: '#a8927a', end: '#7d5a46' },
      { start: '#c9beb0', end: '#a8825f' }
    ];

    return (
      <div className="glass-strong rounded-2xl p-6">
        <h3 className="text-xl font-bold text-brown-900 mb-6 text-center">{title}</h3>
        <div className="flex flex-col md:flex-row items-center gap-8">
          <svg width="200" height="200" className="flex-shrink-0">
            <defs>
              {data.map((item, index) => (
                <linearGradient key={`gradient${index}`} id={`gradient${index}`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor={item.color || colorMap[index % colorMap.length].start} />
                  <stop offset="100%" stopColor={item.color2 || colorMap[index % colorMap.length].end} />
                </linearGradient>
              ))}
            </defs>
            {data.map((item, index) => {
              const angle = (item.value / total) * 360;
              const startAngle = currentAngle;
              const endAngle = currentAngle + angle;
              currentAngle += angle;

              const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
              const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);
              const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
              const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);
              const largeArcFlag = angle > 180 ? 1 : 0;

              return (
                <path
                  key={index}
                  d={`M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2} Z`}
                  fill={`url(#gradient${index})`}
                  className="hover:opacity-80 transition-opacity"
                />
              );
            })}
          </svg>
          <div className="space-y-3">
            {data.map((item, index) => {
              const percentage = ((item.value / total) * 100).toFixed(1);
              return (
                <div key={index} className="flex items-center space-x-3">
                  <div
                    className="w-4 h-4 rounded"
                    style={{ backgroundColor: item.color || '#7d5a46' }}
                  ></div>
                  <span className="text-brown-800 font-medium">{item.label}</span>
                  <span className="text-brown-700 font-semibold ml-auto">{percentage}%</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default SimpleChart;

